var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-input-localized-numeric',{attrs:{"disabled":_vm.disabled,"size":"small"},on:{"change":_vm.onNetPriceChange},model:{value:(_vm.price),callback:function ($$v) {_vm.price=$$v},expression:"price"}})}
var staticRenderFns = []

export { render, staticRenderFns }